//

export const resumeData = {
  main: {
    name: "David Mwangi Wanjiru",
    occupation: "Web & Mobile Developer focused on modern JavaScript and Typescript applications",
    description: "",
    image: "mwas1.webp",
    bio: "Web & Mobile Developer with experience building scalable web and mobile applications using React, Next.js, React Native, JavaScript, and TypeScript. Skilled at turning ideas and designs into functional products, debugging and improving codebases, and collaborating with cross-functional teams. Passionate about problem-solving, learning fast, and contributing to impactful technology, especially in EdTech and social innovation spaces.",
    contactmessage: "Get in touch with me",
    email: "dmwas704@gmail.com",
    phone: "+254 795290373",
    address: {
      street: "Karanja Rd",
      city: "Nairobi",
      state: "Kenya",
      zip: "21104",
    },
    website: "https://david-mwas.vercel.app",
    resumedownload:
      "https://david-mwas.vercel.app/David Mwangi Wanjiru-new-cv-2025.pdf",
    social: [
      {
        name: "github",
        url: "https://github.com/David-mwas",
        className: "fa fa-github",
      },
      {
        name: "twitter",
        url: "#",
        className: "fa fa-twitter",
      },
      {
        name: "linkedin",
        url: "#",
        className: "fa fa-linkedin",
      },
    ],
  },
  resume: {
    skillmessage: "My Programming Language Proficiency & Tools",
    education: [
      {
        school: "Masinde Muliro University of Science and Technology",
        degree:
          "BSc. Information Technology — Second Class Upper Division (Honours)",
        // graduated: "Dec 2025",
        description:
          "Focused on software engineering, web and mobile development, and project-based learning.",
      },
    ],
    work: [
      {
        company: "Tarech Studio",
        title: "Software Developer",
        years: "Apr 2025 – Nov 2025",
        description: `<ul>
<li>Built and maintained responsive, high-performance frontend applications using <strong>React</strong>, <strong>Next.js</strong>, <strong>Tailwind CSS</strong>, and <strong>TypeScript</strong>.</li>
<li>Translated UI/UX wireframes into production-ready interfaces, improving UI responsiveness by 30%.</li>
<li>Integrated REST APIs and Supabase backend services with clean data handling and secure client-side logic.</li>
<li>Worked closely with designers and backend engineers to align system architecture with product requirements.</li>
<li>Participated in testing, debugging, and refining existing features to enhance user experience.</li>
<li>Applied Git, code reviews, and modular component architecture to ensure maintainable, scalable codebases.</li>
</ul>`,
      },
      {
        company: "MMUSTiHub",
        title: "Frontend Developer & Technical Lead",
        years: "May 2023 – Jul 2025",
        description: `<ul>
<li>Developed web and mobile interfaces using <strong>React</strong>, <strong>React Native</strong>, and <strong>Next.js</strong> across multiple student-focused platforms.</li>
<li>Collaborated with product teams to convert ideas and wireframes into functional prototypes and production interfaces.</li>
<li>Integrated real-time data via REST APIs and IoT endpoints for <strong>Fololimo</strong>, an AI/IoT agriculture insights app.</li>
<li>Led frontend QA: performed testing, fixed bugs, reviewed pull requests, and improved code reliability.</li>
<li>Delivered accessible, cross-browser, SEO-friendly interfaces for education and mental health platforms, including <strong>MMUSTJOSA</strong> and <strong>InnerGlow</strong>.</li>
</ul>`,
      },
      {
        company: "ALX Africa",
        title: "Software Engineering Trainee",
        years: "Jun 2022 – Oct 2024",
        description: `<ul>
<li>Built interactive web applications using JavaScript and React, focusing on clean UI and responsive design.</li>
<li>Practiced Agile teamwork, Git workflows, stand-ups, and collaborative project building.</li>
<li>Learned core engineering disciplines: debugging, documentation, testing, and deployment.</li>
</ul>`,
      },
    ],
    projects: [
      {
        name: "KenBest Logistics (Australia)",
        description:
          "Reworked a complete logistics platform from static pages to a scalable React application using Next.js, Supabase, and Tailwind. Implemented reusable components, improved load performance, and built mobile-friendly layouts.",
      },
      {
        name: "Fololimo",
        description:
          "Developed mobile UI screens using React Native, integrating real-time IoT and AI-driven agriculture data through efficient data APIs.",
      },
    ],
    skills: [
      "JavaScript (ES6+)",
      "TypeScript",
      "Python (basic)",
      "React",
      "Next.js",
      "React Native",
      "TailwindCSS",
      "Node.js",
      "Express",
      "REST APIs",
      "Git/GitHub",
      "Supabase",
      "Firebase",
      "Vercel",
      "Postman",
      "Nx Monorepo",
      "Component design",
      "State management",
      "Debugging",
      "QA testing",
      "Performance optimization",
    ],
  },
  testimonials: {
    testimonials: [
      {
        text: "David was my talented workmate at MMUSTiHub, known for building clean, responsive web apps and bringing creative energy to every project. I would definitely recommend him.",
        user: "Michael Maina, Project Developer Lead @MMUSTiHub",
      },
    ],
  },
};
